import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/remote-parties/RemoteParties`;
const baseUrlOcpiVNext = `${process.env.REACT_APP_GITO_API_URL}/ocpi-v2/`;

export async function getRemoteParties(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-all-remote-parties`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response || "Failed to fetch all remote parties");
  }
}

export async function getConfirmedRemoteParties(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-confirmed-remote-parties`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response || "Failed to fetch confirmed remote parties"
    );
  }
}

export async function getOcpiPartner(RemotePartyPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-remote-party/${RemotePartyPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners');
    }
}

// Function to create a new charging point
export async function postCreateParty(partyData, apiAccessToken) {
    try {
        const response = await axios.post(
            `${baseUrlOcpiVNext}generate-new-token-a`,
            partyData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to create charging point"
        );
    }
}

export async function updateRemoteParty(remotePartyData, apiAccessToken) {
    try {
        const response = await axios.put(
            `${baseUrl}/update-remote-party`,
            remotePartyData,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update remote party"
        );
    }
}

export async function updateRemotePartyModules(remotePartyPublicId, identifiers, apiAccessToken) {
    try {
        const response = await axios.put(
            `${baseUrlOcpiVNext}update-remote-party-modules`,
            {
                remotePartyPublicId,
                identifiers,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        const detail =
            error.response?.data?.detail
        throw new Error(detail || "Failed to update remote party modules");
    }
}

export async function postInitiateHandshake(payload, apiAccessToken) {
    try {
        const response = await axios.post(
            `${baseUrlOcpiVNext}initiate-handshake`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to initiate OCPI handshake"
        );
    }
}

export async function deleteRemoteParty(remotePartyPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrlOcpiVNext}/delete-remote-party/${remotePartyPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete remoteParty');
    }
}